import { AuthMeUser } from '@common/types/user';
import { ContentReplacer } from '@components/layout/ContentReplacer';
import { AppsGrid, SearchContent, SearchToolbar } from '@components/layout/search';
import { alpha, Box, useMediaQuery } from '@mui/material';
import { NotificationsBox } from '@notifications/components/display/boxes';
import { Dispatch, PropsWithChildren, SetStateAction } from 'react';

export const HeaderFeaturesWrapper = ({
    children,
    searchState: [search, setSearch],
    notifications,
    apps,
    navigation,
    navigationContent,
    scope,
    scopeLabel,
    onSearchFocus,
    onScopeDelete,
    user,
    userLoading,
    extraToolbar,
    hideSearchBar = false,
}: PropsWithChildren<{
    searchState: [string, Dispatch<SetStateAction<string>>];
    notifications: boolean;
    apps: boolean;
    navigation: boolean;
    navigationContent?: React.ReactNode;
    scope?: string;
    scopeLabel?: string;
    onSearchFocus?: () => void;
    onScopeDelete?: () => void;
    user?: AuthMeUser;
    userLoading?: boolean;
    extraToolbar?: React.ReactNode;
    hideSearchBar?: boolean;
}>) => {
    const isBelowMd = useMediaQuery((theme) => theme.breakpoints.down('md'));

    return (
        <>
            {!hideSearchBar && (
                <Box
                    height={{ xs: 0, md: 93 }}
                    display={{ xs: 'none', md: 'block' }}
                    borderBottom={1}
                    borderColor={alpha('#000', 0.16)}
                    px={{ xs: '24px', lg: '55px' }}
                    bgcolor="#fff"
                >
                    <SearchToolbar
                        search={search}
                        onSearchChange={setSearch}
                        scopeLabel={scopeLabel}
                        onSearchFocus={onSearchFocus}
                        onScopeDelete={onScopeDelete}
                        user={user}
                        userLoading={userLoading}
                    />
                </Box>
            )}
            <ContentReplacer
                isActive={(notifications && isBelowMd) || search.length > 0 || apps || (navigation && isBelowMd)}
                // Search should take precedence over notifications, so if there is a search term, we show the search results instead of the notifications box
                replacementContentWrapperProps={{
                    ...(search.length > 0
                        ? {
                              onClick: (event) => {
                                  if (event.target instanceof Element && event.target.closest('a')) {
                                      setSearch('');
                                  }
                              },
                          }
                        : {}),
                    ...(navigation && isBelowMd ? { maxWidth: 'none', py: 0, px: 0, gap: 0 } : {}),
                }}
                replacementContent={
                    search.length > 0 ? (
                        <SearchContent scope={scope} />
                    ) : notifications ? (
                        <NotificationsBox />
                    ) : apps ? (
                        <AppsGrid />
                    ) : navigation && isBelowMd ? (
                        navigationContent
                    ) : null
                }
                extraToolbar={extraToolbar}
            >
                {children}
            </ContentReplacer>
        </>
    );
};
